import styled from 'styled-components'
import { Text } from '@pinchenterprisesnpm/friday-ui'

// TODO: Remove this styled component when Text component will be exposed with fontStyle property
export const StyledText = styled(Text)`
  font-style: italic;
`
